// empty-state.tsx — dashed placeholder for a section with nothing in it (handoff README §6).
import * as React from 'react';
import type { LucideIcon } from 'lucide-react';

import { cn } from '../lib/utils.ts';

function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon: LucideIcon;
  /** The NEXT ACTION, phrased as one — "Point it at your site", never the absence
   * ("No sources yet"). Where there is genuinely nothing left to do, say so warmly:
   * "Nothing to fix — your bot has answered everything it was asked." (handoff README §6) */
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        'flex flex-col items-center gap-2 rounded-xl border border-dashed border-border p-8 text-center',
        className,
      )}
    >
      <span className="grid size-[34px] place-items-center rounded-lg bg-muted text-muted-foreground">
        <Icon size={17} strokeWidth={1.9} aria-hidden="true" />
      </span>
      <strong className="text-sm font-semibold">{title}</strong>
      {description && (
        <p className="max-w-[34ch] text-[12.5px] text-muted-foreground">{description}</p>
      )}
      {action}
    </div>
  );
}

export { EmptyState };
